import React from "react";
import OntImg from "../../../../assets/images/ont-huawei.png";

import './styles.css';

const Ont = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="siglas-title">
                    <h1>Título</h1>
                </div>
                <div className="col-sm-12">
                    <div className="siglas">
                        <img src={OntImg} alt="siglas" />
                    </div>
                </div>                
            </div>
        </div>
    );
};
export default Ont;